import { getSortingResult, SortDirection } from 'utilities'
import { CardsSettings, LayoutSettings } from './DashboardPageStore.types'

export function getOrderedSectionLabels<T> (
  settings: LayoutSettings | CardsSettings,
  options?: { skipInvisible?: boolean }
): T[] {
  let orderedSettings = Object.entries(settings)
    .sort((a, b) => {
      const positionA = a[1].position
      const positionB = b[1].position
      return getSortingResult(positionA, positionB, SortDirection.ASC)
    })

  if (options?.skipInvisible) {
    orderedSettings = orderedSettings.filter(([_, settingsData]) => settingsData.visible)
  }

  return orderedSettings.map(([label]) => label as unknown as T)
}
